export const radioFieldStyle = { width: '100%', display: 'flex', '.MuiTypography-root': { width: '100%' } };

export const consentBoxItemStyle = {
    mb: '30px'
};